// extracted by mini-css-extract-plugin
export default {"container":"MyDive_container__PIxUg","pageTitle":"MyDive_pageTitle__UWHhf","priceList":"MyDive_priceList__9wiNL","navigation":"MyDive_navigation__gnUyd"};